import { IFeedDataKeyValueItem } from '@domain/feed';

const REGEX_NUMBER = /^-?\d+(\.\d+)?(e-?\d+)?$/gi;

export function isValidUrl(urlString: string): boolean {
    if (typeof urlString !== 'string') return false;

    if (urlString !== urlString.trim()) return false;

    try {
        const url = new URL(urlString);

        // Only allow http and https (like C# [Url] or UriKind.Absolute + validation)
        if (!['http:', 'https:'].includes(url.protocol)) return false;

        if (url.hostname.includes('?') || url.hostname.includes('"')) return false;
        // Must have valid hostname
        if (!url.hostname || /\s/.test(url.hostname)) return false;

        // Enforce FQDN (at least one dot)
        if (!url.hostname.includes('.')) return false;

        // Hostname rules (per C# and DNS standards)
        if (url.hostname.startsWith('.') || url.hostname.includes('..')) {
            return false;
        }

        return true;
    } catch {
        return false;
    }
}

export function isValidNumber(num: string): boolean {
    return typeof num === 'string' ? REGEX_NUMBER.test(num) : false;
}

export function validateFeedData(feedData: IFeedDataKeyValueItem[]): void {
    const InvalidFeedError = new Error(`
    Attempt to override a feed with invalid feed data. The feed data has to follow the following schema:

    [
        {
            MyFeedItemKey: {
                value: 'feed value',
                targetUrl: 'https://website.com'
            },
            MyFeedItemKey2: {
                value: 'feed value',
                targetUrl: 'https://website.com'
            }
        }
    ]
    `);

    if (!Array.isArray(feedData)) {
        throw InvalidFeedError;
    }
    for (const dataItem of feedData) {
        if (typeof dataItem !== 'object') {
            throw InvalidFeedError;
        }

        for (const item of Object.keys(dataItem)) {
            if (!Object.prototype.hasOwnProperty.call(dataItem[item], 'value')) {
                throw InvalidFeedError;
            }
        }
    }
}
